export const buildUrlWithParams = (baseUrl, params, separator = '?') => {
  const queryString = new URLSearchParams(params).toString();

  return `${ baseUrl }${ separator }${ queryString }`;
};

export const isNumber = value => typeof value === 'number' && !isNaN(value);

export const isPositiveNumber = (value, zeroIncluded = false) =>
  isNumber(value) && (zeroIncluded ? (value >= 0) : (value > 0));

export const parseJsonString = (data) => {
  let parsedData;

  try {
    parsedData = JSON.parse(data);
  } catch {
    parsedData = null;
  }

  return parsedData;
};

export const generateRandomNumberInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
